<template>
  <div class="select-cv-main">
    <div class="cover" @click="$emit('close')"></div>
    <transition name="optity">
      <div class="box main" @click.stop>
        <i class="close iconfont iconx" @click.stop="close"></i>
        <div class="title">升级会员，继续编辑</div>
        <div class="msg">免费版仅可编辑 1 份中文简历、1 份英文简历</div>
        <template v-if="!cnCanEditable">
          <div class="name">中文简历</div>
          <el-select v-model="cvsCnValue" placeholder="请选择">
            <el-option
                v-for="item in cvsCn"
                :key="item.token"
                :label="item.name || item.cv_name"
                :value="item.token"/>
          </el-select>
        </template>
        <template v-if="!enCanEditable">
          <div class="name">英文简历</div>
          <el-select v-model="cvsEnValue" placeholder="请选择">
            <el-option
                v-for="item in cvsEn"
                :key="item.token"
                :label="item.name || item.cv_name"
                :value="item.token"/>
          </el-select>
        </template>
        <div class="btn">
          <button @click="selectCv">确定选择简历</button>
          <button class="active" @click="upVip">升级超级会员</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
export default {
  name: 'SelectCv',
  props: [
    'cvsEn',
    'cvsCn',
  ],
  data() {
    return {
      cvsCnValue: '',
      cvsEnValue: ''
    };
  },
  created(){
    document.body.style.position = 'initial'
    document.body.style.overflow = 'initial'
    this.initSelectCvValue()
  },
  beforeDestroy(){
    document.body.style.position = 'static'
    document.body.style.overflow = 'hidden'
  },
  computed: {
    cnCanEditable() {
      return this.cvsCn.find(item => item.can_editable)
    },
    enCanEditable() {
      return this.cvsEn.find(item => item.can_editable)
    }
  },
  methods: {
    initSelectCvValue() {
      if (!this.cnCanEditable) {
        this.cvsCnValue = this.cvsCn[0].token
      }
      if (!this.enCanEditable) {
        this.cvsEnValue = this.cvsEn[0].token
      }
    },
    close() {
      this.$emit('close');
    },
    upVip() {
      this.$emit('close');
      this.$store.dispatch('app/setAlertData', { show: true, type: 'upVip', browseType: 'cvMerge' });
    },
    async selectCv() {
      if (!this.cvsCnValue && !this.cvsEnValue) {
        this.$message.error('请选择简历');
        return false;
      }
      let res = {}
      let res1 = {}
      if (this.cvsEnValue) {
        res = await api.cvsV3.editableCv({
          lang: "en",
          token: this.cvsEnValue
        });
      } else {
        res = { code: 1000 }
      }
      if (this.cvsCnValue) {
        res1 = await api.cvsV3.editableCv({
          lang: "cn",
          token: this.cvsCnValue
        });
      } else {
        res1 = { code: 1000 }
      }
      if (res.code === 1000 && res1.code === 1000) {
        this.$emit('close');
        this.$emit('updated');
      }else {
        this.$message.error('请求出错');
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.select-cv-main {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  &>* {
    box-sizing: border-box;
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
  }
  .close {
    position: absolute;
    top: 38px;
    right: 38px;
    cursor: pointer;
    font-size: 16px;
    color: #9C9C9C;
    font-weight: 600;;
  }
  .box {
    // position: fixed;
    position: relative;
    background: #fff;
    width: 454px;
    overflow: hidden;
    border-radius: 4px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    padding: 31px;
    box-sizing: border-box;
    z-index: 2;
    .title {
      font-size: 18px;
      color: #404040;
      font-weight: 700;
    }
    .msg {
      font-size: 14px;
      color: #606060;
      margin-top: 16px;
    }
    .name {
      font-size: 14px;
      color: #404040;
      margin-top: 24px;
      margin-bottom: 10px;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 48px;
      button {
        display: block;
        width: 168px;
        height: 42px;
        border: 1px solid #FF282F;
        color: #FF282F;
        border-radius: 4px;
        font-size: 16px;
        background: transparent;
        &.active {
          color: #fff;
          background: #FF4F4C;
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .select-cv-main {
    .el-select {
      width: 100%;
      height: 44px;
      .el-input__inner,
      .el-input {
        height: 100%;
      }
    }
  }
</style>